export const informationTitle = 'Your Information';
export const schoolTitle = 'School Information';
export const supportTitle = 'Support Documents';
export const uploadTitle = 'Upload an attachment';
export const uploadLink = 'Choose File';
export const link = 'Request Education Quote';
